<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      formData: {
        skor: "",
        text_jawaban: "",
      },
    };
  },
  mounted() {
  },
  methods: {
    // Tambah select baru
    submitForm() {
      Swal.fire({
        title: "Loading...",
        html: "<i class='fa fa-spinner fa-spin'></i> ",
        showConfirmButton: false,
        allowOutsideClick: false
      });
      const authToken = localStorage.access_token;

      let payload = { ...this.formData };
      axios
        .post(
          process.env.VUE_APP_BACKEND_URL_VERSION + "master/jawaban-survei",
          payload,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("Response submit:", response.data);
          this.resetForm();
          Swal.fire({
            icon: "success",
            title: "Berhasil menambah jawaban",
            timer: 2000,
            showConfirmButton: false
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              this.$emit("refresh");
              this.$emit("close");
            }
          });
        })
        .catch((error) => {
          // Handle errors
          console.error("Error:", error.response.data);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.response?.data?.data,
            timer: 2000
          })
        });
    },
    resetForm() {
      this.formData.skor = "";
      this.formData.text_jawaban = "";
    },
  },
};
</script>

<style scoped>
/* Add your custom styles here if needed */
</style>

<template>
  <div class="container">
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="mb-3">
        <label for="skor" class="form-label">Skor</label>
        <input
          v-model="formData.skor"
          type="integer"
          class="form-control"
          id="skor"
          required
        />
      </div>

      <div class="mb-3">
        <label for="jawaban" class="form-label">Jawaban</label>
        <textarea
          v-model="formData.text_jawaban"
          class="form-control"
          id="jawaban"
          required
        ></textarea>
      </div>

      <div class="mb-3">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
</template>
